import "@ant-design/v5-patch-for-react-19";
import "@fontsource-variable/manrope";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/600.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp, ConfigProvider } from "antd";
import itIT from "antd/locale/it_IT";
import enGB from "antd/locale/en_GB";
import { useTranslation } from "react-i18next";
import "./i18n";
import { globalCss, theme } from "./theme";
import { AuthProvider } from "./auth/AuthContext";
import App from "./App";
import { ApiError } from "./api/client";

// niente nuovi tentativi sugli errori del client e sulle rotte non ancora disponibili (501)
const qc = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: (n, e) => n < 1 && !(e instanceof ApiError && e.status >= 400 && e.status < 600 && e.status !== 503) } },
});

/** Locale di Ant Design (date, paginazione, conferme) dalla lingua dell'interfaccia. */
function Radice({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  return (
    <ConfigProvider theme={theme} locale={i18n.language === "it" ? itIT : enGB}>
      {children}
    </ConfigProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Radice>
      <style>{globalCss}</style>
      <AntApp>
        <QueryClientProvider client={qc}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </AntApp>
    </Radice>
  </StrictMode>,
);
